import { render, staticRenderFns } from "./KernelOrderFilesList.vue?vue&type=template&id=dd758f0c&"
import script from "./KernelOrderFilesList.vue?vue&type=script&lang=js&"
export * from "./KernelOrderFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports